module.exports = __webpack_public_path__ + "static/media/M.TECH.CS.IIITL.23.05.19-converted-2.5786f356.pdf";